import { useSearchParams } from 'react-router-dom';

function useComparisonParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const leftEpochMillis = searchParams.get('leftEpochMillis') as string;
  const rightEpochMillis = searchParams.get('rightEpochMillis') as string;

  const changeSearchParams = (key: 'leftEpochMillis' | 'rightEpochMillis', value: string) => {
    searchParams.set(key, value);
    setSearchParams(searchParams);
  };

  return {
    changeSearchParams,
    leftEpochMillis,
    rightEpochMillis,
  };
}

export default useComparisonParams;
